export const TRANSLATIONS_JP = {
  username: "ユーザー名",
  password: "パスワード",
  login: "ログイン",
  registerMsg: "まだ登録していない？",
  registerMsg2: "こちらをクリック",
  modalMsg: "パスワードと/またはユーザー名が間違っています",
};
